<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="stylus" type="text/stylus">
@import "./assets/iconfont/iconfont.css"
@import "./assets/css/element-ui-initialize.styl"

body, html
  margin 0
  padding 0
  width 100%
  border none

body
  font-family: "Microsoft YaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  a
    text-decoration none
#app
  width 100%

*
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: none !important;

/* 滚动条样式 */
*::-webkit-scrollbar-track
  background-color: #ddd;
  border-radius: 4px;
  width: 4px;
  z-index: 100;
  position: relative;

*::-webkit-scrollbar
  width: 4px;
  height: 8px;
  background-color: transparent;
  z-index: 100;
  position: relative;

*::-webkit-scrollbar-thumb
  border-radius: 4px;
  background-color: #999;
  z-index: 100;
  position: relative;

*::-webkit-scrollbar:horizontal:decrement:hover
  height: 16px;
/* 滚动条样式end */
</style>



// WEBPACK FOOTER //
// src/App.vue